import { PaginationSearchParams, SearchQuery, Uuid } from '@/api/types';
import { CaseStatus } from './status';
import { OrganType } from './clinical-data.types';
import { AssignedUsersByGroup, CaseUserGroup, DonorType } from './case.types';
import { EmployeeRole } from '../resources/resources.types';

export enum BulkSagaState {
  Pending = 'Pending',
  InProgress = 'InProgress',
  Completed = 'Completed',
  Failed = 'Failed',
}

export type BulkEmployeeData = {
  employeeId: Uuid;
  firstName: string;
  lastName: string;
  roles: EmployeeRole[];
};

export type BulkAssignmentCase = {
  caseId: string;
  caseName: string;
  status: CaseStatus;
  donorHospitalDate: string;
  donorHospitalTime: string;
  donorHospitalTimeZone: string;
  serviceRegionId: string;
  organType: OrganType;
  donorType: DonorType;
  assignedEmployees: AssignedUsersByGroup;
};

export type BulkAssignmentOperationType = 'Swap' | 'Assign' | 'Detach';

export type BulkAssignmentOperation = {
  $type: BulkAssignmentOperationType;
  detachedEmployeeId: Uuid;
  assigningEmployeeId: Uuid;
  group: CaseUserGroup;
  assignAsPrimary: boolean | null;
  operationId: Uuid;
  correlationId: Uuid;
  caseId: Uuid;
  status: BulkSagaState;
  errorMessage: string | null;
};

export type BulkAssignmentStatusData = {
  correlationId: Uuid;
  currentState: BulkSagaState;
  initiatedByUserId: Uuid;
  operations: BulkAssignmentOperation[];
  relatedEmployees: BulkEmployeeData[];
};

export type BulkAssignmentCasesPayload = {
  searchTerm?: string;
  organType?: OrganType;
  group?: CaseUserGroup;
  userToDetach?: Uuid;
  userToAssign?: Uuid;
};

export type BulkAssignmentPayloadOperation = {
  $type: BulkAssignmentOperationType;
  caseId: Uuid;
  detachedEmployeeId: Uuid;
  assigningEmployeeId: Uuid;
  group: CaseUserGroup;
  assignAsPrimary?: boolean | null;
};

export type StartBulkAssignmentResult = {
  correlationId: Uuid;
};

export type PaginatedBulkAssignmentCasesPayload = PaginationSearchParams & SearchQuery & BulkAssignmentCasesPayload;
